import React, { useEffect, useState } from "react";
import {
  Facebook,
  Github,
  Mail,
  Twitter,
  Eye,
  EyeOff,
  Loader,
  Loader2,
  Home,
} from "lucide-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import SWL from "sweetalert2";
import { Link, Navigate, NavLink, useNavigate } from "react-router-dom";

import img1 from "assets/images/cheerful-cartoon-chicken-illustration_1308-177231.jpg";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import Api from "Common/Components/ApiInterceptor/Api";
import { getfullnameFromToken, getRoleId } from "Common/Components/getRoleId";
import Swal from "sweetalert2";
import { useMyContext } from "hooks/MyContaxtApi";
import { DEFAULT_CROP_YEAR_ID } from "Common/constants/cropYear";

type Contractor = {
  id: number;
};

const LoginBoxed = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contractors, setContractors] = useState<Contractor[]>([]);
  const [loadingContractors, setLoadingContractors] = useState(false);
  const { userInfo, refreshUserInfo } = useMyContext();

  const showpass = () => {
    setPasswordVisible(!passwordVisible);
  };
  const Navigate = useNavigate();
  document.title = "صفحه ورود به سامانه هاویر کشت ";
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      username: "",
      contractor_id: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("رمز عبور نباید خالی باشد"),
      username: Yup.string().required(" نام کاربری یا ایمیل نباید خالی باشد"),
      contractor_id: Yup.number()
        .typeError("شناسه پیمانکار باید یک عدد باشد")
        .required("شناسه پیمانکار نباید خالی باشد")
        .min(0, "شناسه پیمانکار باید بین ۰ تا ۹۹ باشد")
        .max(99, "شناسه پیمانکار باید بین ۰ تا ۹۹ باشد"),
    }),

    onSubmit: async (values) => {
      if (values) {
        try {
          setLoading(true);
          const formData = new FormData();
          formData.append("username", values.username.trim());
          formData.append("password", values.password.trim());
          formData.append("contractor_id", values.contractor_id);
          const res = await Api.post("/token", formData);
          if (res?.status === 200) {
            localStorage.setItem(
              "crop_year_id",
              String(DEFAULT_CROP_YEAR_ID)
            );
            console.log(res, res);
            const userRole = getRoleId(res?.data?.access_token);
            const userFullName = getfullnameFromToken(res?.data?.access_token);
            setLoading(false);
            if (userRole === 5) {
              Navigate("/ReadyLoad");
            } else {
              if (userRole === 1) {
                if (localStorage.getItem("crop_year_id")) {
                  Navigate("/DashBoard");
                } else {
                  Navigate("/Year-registration");
                }
              } else if (userRole === 3) {
                Swal.fire(
                  "خوش آمدید",
                  `کشاورز گرامی ${userFullName} به صفحه کاربری خوش آمدید`,
                  "success"
                );
                if (localStorage.getItem("crop_year_id")) {
                  Navigate("/userDashboard");
                } else {
                  Navigate("/Year-registration");
                }
              } else {
                if (localStorage.getItem("crop_year_id")) {
                  Navigate("/DashBoard");
                } else {
                  Navigate("/Year-registration");
                }
              }
            }

            toast.success("ورود با موفقیت انجام شد");
          }
        } catch (error: any) {
          console.log(error);
          setLoading(false);
          if (error?.response?.status === 403) {
            toast.error(
              "لطفا با مدیر سامانه تماس بگیرید، حساب کاربری شما غیرفعال است"
            );
          } else if (error?.response?.status === 401) {
            toast.error("نام کاربری یا رمز عبور اشتباه است");
          } else {
            toast.error("مشکلی به وجود آمده است، لطفا مجددا تلاش کنید");
          }
        }
      } else {
        toast.error("لطفا اطلاعات را کامل وارد کنید");
      }
    },
  });

  useEffect(() => {
    const fetchContractors = async () => {
      try {
        setLoadingContractors(true);
        const response = await Api.get("/public/contractors");
        const list = response?.data?.contractors ?? [];
        setContractors(Array.isArray(list) ? list : []);
      } catch (error) {
        setContractors([]);
        // toast.error("دریافت لیست پیمانکاران با خطا مواجه شد");
      } finally {
        setLoadingContractors(false);
      }
    };

    fetchContractors();
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    formik.handleSubmit(); // Manually trigger form validation and submission
  };

  return (
    <div className="min-h-screen">
      <header className="bg-white shadow-sm drop-shadow-lg py-4 px-6 dark:bg-gray-800" dir="rtl">
        <nav className="container mx-auto flex flex-row items-center justify-start gap-5">
          <div className="text-lg font-semibold text-blue-600 dark:text-blue-400">
            سامانه پیمانکاران چغندرقند هاویر کشت
          </div>
          <div className="flex items-center gap-2 text-gray-800 dark:text-gray-200 text-base cursor-pointer hover:text-blue-700 transition-colors duration-200">
            <Home size={18} />
            <NavLink to="/landingpage">صفحه اصلی</NavLink>
          </div>
        </nav>
      </header>

      <div
        className="flex items-center justify-center h-[85vh] overflow-hidden px-4  bg-cover bg-auth-pattern dark:bg-auth-pattern-dark dark:text-zink-100 font-public"
        dir="rtl"
      >
        <div className="flex justify-center items-center h-screen">
          <ToastContainer
            position="top-center" // موقعیت وسط
            closeButton={false} // حذف دکمه بستن
            limit={1} // محدود کردن تعداد پیام‌ها
            rtl={true} // فعال کردن راست‌چین
            className="font-Bold text-lg"
          />
        </div>
        <div className="mb-0 shadow-none xl:w-96 border border-gray-200  border-1 card bg-gray-100 center dark:bg-zink-500/70">
          <div className="grid grid-cols-1 gap-0 lg:grid-cols-12">
            <div className="lg:col-span-12">
              <div className="!px-12 !py-12 card-body">
                <div className="text-center">
                  <h4 className="mb-2 text-purple-500 dark:text-purple-500">
                    صفحه ورود
                  </h4>
                  <p className="text-slate-500 dark:text-zink-200">
                    صفحه ورود به سامانه هاویر کشت
                  </p>
                </div>

                <form
                  action="/"
                  className="mt-10"
                  id="signInForm"
                  dir="rtl"
                  onSubmit={formik.handleSubmit}
                >
                  <div
                    className="hidden px-4 py-3 mb-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
                    id="successAlert"
                  >
                    You have <b>successfully</b> signed in.
                  </div>
                  <div className="mb-3">
                    <label
                      htmlFor="contractor_id"
                      className="inline-block mb-2 text-base font-medium"
                    >
                      پیمانکار
                    </label>
                    <input
                      type="number"
                      id="contractor_id"
                      name="contractor_id"
                      min={0}
                      max={99}
                      className="form-input dark:bg-zink-600/50 border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="شناسه پیمانکار (۰ تا ۹۹)"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.contractor_id}
                    />
                    {formik.touched.contractor_id &&
                      formik.errors.contractor_id ? (
                      <p className="text-red-800">{formik.errors.contractor_id}</p>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      htmlFor="username"
                      className="inline-block mb-2 text-base font-medium"
                    >
                      نام کاربری
                    </label>
                    <input
                      type="text"
                      id="username"
                      // value={formik.values.username}
                      name="username"
                      autoComplete="off"
                      className="form-input dark:bg-zink-600/50 border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="نام کاربری  را وارد کنید"
                      onChange={formik.handleChange}
                      value={formik.values.username}
                    />
                    {formik.touched.username && formik.errors.username && (
                      <p className="text-red-800">{formik.errors.username}</p>
                    )}
                    <div
                      id="username-error"
                      className="hidden mt-1 text-sm text-red-500"
                    >
                      Please enter a valid email address.
                    </div>
                  </div>
                  <div className="mb-3 relative">
                    <label
                      htmlFor="password"
                      className="inline-block mb-1 text-base font-medium"
                    >
                      رمز عبور
                    </label>
                    <input
                      type={passwordVisible ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-input dark:bg-zink-600/50 border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 pr-10" // اضافه کردن padding-right برای فضای آیکن
                      placeholder="رمز عبور خود را وارد کنید"
                      autoComplete="off"
                      onChange={formik.handleChange}
                      value={formik.values.password}
                    />
                    {formik.touched.password && formik.errors.password && (
                      <p className="text-red-800">{formik.errors.password}</p>
                    )}
                    <button
                      type="button"
                      className="absolute mt-3 left-3 top-1/2 transform -translate-y-1/2"
                      onClick={() => setPasswordVisible(!passwordVisible)}
                    >
                      {passwordVisible ? (
                        <EyeOff className="text-gray-500" />
                      ) : (
                        <Eye className="text-gray-500" />
                      )}
                    </button>
                    <div
                      id="password-error"
                      className="hidden mt-1 text-sm text-red-500"
                    >
                      Password must be at least 8 characters long and contain
                      both letters and numbers.
                    </div>
                  </div>

                  <div>
                    <div className="flex items-center gap-2">
                      <input
                        id="checkboxDefault1"
                        className="size-4 border rounded-sm appearance-none bg-slate-100 border-blue-400 dark:bg-zink-600/50 dark:border-zink-500 checked:bg-custom-500 checked:border-custom-500 dark:checked:bg-custom-500 dark:checked:border-custom-500 checked:disabled:bg-custom-400 checked:disabled:border-custom-400"
                        type="checkbox"
                        value=""
                      />
                      <label
                        htmlFor="checkboxDefault1"
                        className="inline-block text-base font-medium align-middle cursor-pointer"
                      >
                        مرا به یاد داشته باش
                      </label>
                    </div>
                    <div
                      id="remember-error"
                      className="hidden mt-1 text-sm text-red-500"
                    >
                      Please check the "Remember me" before submitting the form.
                    </div>
                  </div>
                  <div className="mt-10">
                    <button
                      type="submit"
                      disabled={loading}
                      className={`w-full text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20 ${loading ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                    >
                      {loading ? (
                        <div className="flex justify-center items-center ">
                          لطفا صبر کنید...
                          <Loader2 className="w-6 h-6 mr-2 animate-spin" />
                        </div>
                      ) : (
                        "ورود به سامانه"
                      )}
                    </button>
                  </div>

                  <div className="relative text-center my-9 before:absolute before:top-3 before:left-0 before:right-0 before:border-t before:border-t-slate-200 dark:before:border-t-zink-500">
                    <h5 className="inline-block px-2 py-0.5 text-sm bg-white text-slate-500 dark:bg-zink-600 dark:text-zink-200 rounded relative">
                      ورود از طریق{" "}
                    </h5>
                  </div>

                  <a
                    href="#"
                    onClick={() =>
                      toast.success("لطفا با مدیر سامانه تماس بگیرید")
                    }
                    className="text-blue-800 mx-auto flex justify-center"
                  >
                    پسورد خود را فراموش کرده ام؟
                  </a>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer
        className="bg-white text-black py-3 text-sm text-center px-4"
        dir="rtl"
      >
        کلیه حقوق مادی و معنوی این سامانه متعلق به شرکت هاویر (
        <a
          href="https://www.havir.ir"
          className="text-blue-600 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.Havir.ir
        </a>
        ) می‌باشد.
      </footer>
    </div>
  );
};

export default LoginBoxed;
